import * as React from "react";
import Dialog from "@mui/material/Dialog";
import "../css/dialog.css";
import { BiMessage } from "react-icons/bi";
import { RxCross1 } from "react-icons/rx";
import { FaSpinner } from "react-icons/fa"; // Spinner icon
import toast from "react-hot-toast";
import axios from "axios";

function SimpleDialog(props) {
  const { candidates, appliedJobId, employerId, open, onClose } = props;

  const [message, setMessage] = React.useState("");
  const [loading, setLoading] = React.useState(false); // Loading state
  const textareaRef = React.useRef(null);

  const handleClose = () => {
    setMessage("");
    setLoading(false);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (message && message.length > 3500) {
      textareaRef.current.focus();
      return;
    }

    setLoading(true); // Start loading
    try {
      const response = await axios.post(
        "/api/employer/messagecandidate",
        { sender: employerId, receiver: candidates.map((i) => [i._id, i.user]), appliedJobId, message },
        {
          headers: {
            "Content-Type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      );
      const data = await response.data;
      console.log(data);
      toast.success(data.message);
      setMessage("");
    } catch (err) {
      toast.error("Unable to send message");
    } finally {
      setLoading(false); // Stop loading
      handleClose();
    }
  };

  return (
    <Dialog className="dialog" onClose={handleClose} open={open}>
      <div className="dialog-container">
        <div className="title">
          <BiMessage /> Workcroft Chat
          <span style={{ cursor: "pointer" }} onClick={handleClose}>
            <RxCross1 />
          </span>
        </div>

        <div className="candidate-list">
          <span>Message to:</span>
          {candidates.map((candidate, index) => (
            <span key={index}>
              {candidate?.resume?.PersonalDetails?.firstName} {candidate?.resume?.PersonalDetails?.lastName}
            </span>
          ))}
        </div>

        <form onSubmit={handleSubmit} className="w-100">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Write a message..."
            className="w-100"
            rows="10"
            style={{ borderColor: message && message.length > 3500 ? "red" : "", paddingLeft: "20px" }}
            ref={textareaRef}
          ></textarea>
          {message && message.length > 3500 && (
            <p className="text-end" style={{ fontSize: "13px", color: "red" }}>
              Please limit your input to 3500 characters or less
            </p>
          )}

          <button type="submit" disabled={loading} className="send-btn">
          {loading ? (
              <>
                Sending Message <FaSpinner className="spinner" /> 
              </>
            ) : (
              "Send Message"
            )}
          </button>
        </form>
      </div>
    </Dialog>
  );
}

export default SimpleDialog;
